export default __webpack_public_path__ + "static/media/high_return.78c9d198.png";